import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display"]
  
  connect() {
    setTimeout(() => this.updateDisplay(), 100)
  }
  
  counterChange(event) {
    // This method gets called when any counter changes
    this.updateDisplay()
  }
  
  updateDisplay() {
    const parts = []
    
    // Find all counter controllers within this element
    this.element.querySelectorAll('[data-controller*="counter"]').forEach((counterEl) => {
      const controller = this.application.getControllerForElementAndIdentifier(counterEl, "counter")
      if (controller && controller.count > 0) {
        // Get pet type info from data attributes
        const petName = counterEl.dataset.petName
        const petPlural = counterEl.dataset.petPlural
        
        if (petName) {
          const displayName = controller.count === 1 ? petName : (petPlural || petName + 's')
          parts.push(`${controller.count} ${displayName}`)
        }
      }
    })
    
    if (parts.length === 0) {
      this.displayTarget.value = "How many pets?"
    } else {
      this.displayTarget.value = parts.join(', ')
    }
  }
}
